import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { A11yModule } from '@angular/cdk/a11y';
import { SurveySnackBarComponent } from './survey-snack-bar.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		GoMaterialModule,
		FocusOnFirstInvalidFieldModule,
		A11yModule
	],
	declarations: [
		SurveySnackBarComponent
	],
	exports: [
		SurveySnackBarComponent
	]
})
export class  SurveySnackBarModule {}
